module.exports = __webpack_public_path__ + "static/media/back.3fb78d7b.svg";